import { KeenIcon } from '@/components';

export interface DashboardStatCardProps {
  title: string;
  value: number;
  description: string;
  icon: string;
  loading?: boolean;
  variant?: 'default' | 'primary';
  highlight?: boolean;
  /** When set, shown instead of numeric value (e.g. formatted currency). */
  displayValue?: string;
}

export const DashboardStatCard = ({
  title,
  value,
  description,
  icon,
  loading,
  variant = 'default',
  highlight = false,
  displayValue,
}: DashboardStatCardProps) => {
  const baseCardClasses =
    'rounded-lg border border-gray-500 text-gray-900 shadow-md p-6';

  const primaryClasses = 'bg-primary text-white border-none';
  const highlightRing = highlight ? ' ring-2 ring-primary/40' : '';

  const cardClasses =
    variant === 'primary'
      ? `${baseCardClasses} ${primaryClasses}${highlightRing}`
      : `${baseCardClasses}${highlightRing}`;

  const titleClasses =
    'text-xs uppercase tracking-wide ' +
    (variant === 'primary' ? 'text-white/80' : 'text-gray-500');

  const valueClasses =
    'text-2xl font-semibold ' +
    (variant === 'primary' ? 'text-white' : 'text-gray-900');

  const descriptionClasses =
    'text-[11px] mt-1 ' +
    (variant === 'primary' ? 'text-white/80' : 'text-gray-500');

  const iconWrapperClasses =
    'h-10 w-10 rounded-full flex items-center justify-center ' +
    (variant === 'primary' ? 'bg-white/20' : 'bg-primary/10');

  const iconClasses =
    variant === 'primary' ? 'text-white text-lg' : 'text-primary text-lg';

  return (
    <div className={cardClasses}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col">
          <span className={titleClasses}>{title}</span>
          <span className={valueClasses}>
            {loading ? '-' : displayValue ?? value}
          </span>
          <span className={descriptionClasses}>{description}</span>
        </div>
        <div className={iconWrapperClasses}>
          <KeenIcon icon={icon} className={iconClasses} />
        </div>
      </div>
    </div>
  );
};
